import React from 'react';
import { Route, Switch } from 'react-router';

// Getting-Started
import Sidebar from './getting-started/Sidebar';
// Shared
import Footer from './shared/Footer';
import HtmlPage from './getting-started/HtmlPage';
import SimpleTasks from './getting-started/SimpleTasks';
import SidebarDropdown from './getting-started/SidebarDropdown';

// Presentational Component
const GettingStarted = () => {
	return (
		<div className="page">
			<Sidebar />
			<main id="content" className="content with-sidebar">
				<div className="section">
					<div className='responsive-small'>
						<SidebarDropdown />
					</div>
					<Switch>
						<Route exact path="/getting-started" render={() => <HtmlPage page="introduction" />} ></Route>
						<Route path="/getting-started/simple-tasks/:task?" component={SimpleTasks}></Route>
						<Route exact path="/getting-started/:page" render={({ match }) => <HtmlPage page={match.params.page} />}></Route>
					</Switch>
				</div>
				<Footer />
			</main>
		</div>
	);
};

export default GettingStarted;



// WEBPACK FOOTER //
// ./src/components/GettingStarted.js